import { render, staticRenderFns } from "./ChallengeEmail.vue?vue&type=template&id=2c354f4a&scoped=true"
import script from "./ChallengeEmail.vue?vue&type=script&lang=js"
export * from "./ChallengeEmail.vue?vue&type=script&lang=js"
import style0 from "./ChallengeEmail.vue?vue&type=style&index=0&id=2c354f4a&prod&scoped=true&lang=css"
import style1 from "./ChallengeEmail.vue?vue&type=style&index=1&id=2c354f4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c354f4a",
  null
  
)

export default component.exports